export default {
  methods: {
    roundNumber(number, precision = 0) {
      const factor = 10**precision;
      return Math.round(number * factor) / factor;
    },
    parseSymbol(symbol) {
      if (symbol?.endsWith(".IS") || symbol?.endsWith(".TF")) {
        return { code: symbol.split(".")[0] }
      }
      return { code: symbol }
    }
  }
}
